'use client';

import { useScrollDepthTracking } from '@/features/landing/hooks/useSectionVisibility';

/**
 * Client component that tracks scroll depth milestones (25%, 50%, 75%, 100%).
 * Place this component in any page or layout where you want to track scroll behavior.
 *
 * @example
 * // In a page component:
 * export default function LandingPage() {
 *   return (
 *     <>
 *       <ScrollDepthTracker />
 *       <HeroSection />
 *       ...
 *     </>
 *   );
 * }
 *
 * @example
 * // In a layout:
 * export default function MarketingLayout({ children }) {
 *   return (
 *     <>
 *       <ScrollDepthTracker />
 *       {children}
 *     </>
 *   );
 * }
 */
export function ScrollDepthTracker() {
  useScrollDepthTracking();
  return null;
}
